import React from 'react';
import { motion } from 'framer-motion';
export function GuaranteeSection() {
  return <section className="w-full bg-[#FFF8F0] py-16 sm:py-24 px-4" data-id="element-95">
      <div className="max-w-3xl mx-auto" data-id="element-96">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5
      }} className="bg-white rounded-3xl p-8 sm:p-12 text-center shadow-sm border-2 border-[#F5C84B]/30 relative overflow-hidden" data-id="element-97">
          {/* Decorative background circle */}
          <div className="absolute top-0 right-0 -mt-10 -mr-10 w-40 h-40 bg-[#F5C84B]/10 rounded-full blur-2xl pointer-events-none" data-id="element-98" />
          <div className="absolute bottom-0 left-0 -mb-10 -ml-10 w-40 h-40 bg-[#F5A04B]/10 rounded-full blur-2xl pointer-events-none" data-id="element-99" />

          <div className="relative z-10" data-id="element-100">
            <div className="text-5xl sm:text-6xl mb-6" data-id="element-101">🛡️</div>
            <h2 className="text-2xl sm:text-3xl font-black text-[#3D3935] mb-2 uppercase tracking-wide" data-id="element-102">
              GARANTÍA ITERAPRO™
            </h2>
            <h3 className="text-xl sm:text-2xl font-black text-[#F5A04B] mb-6" data-id="element-103">
              100% GARANTÍA DE 7 DÍAS
            </h3>
            <p className="text-[#8B7E76] text-base sm:text-lg font-medium leading-relaxed max-w-2xl mx-auto" data-id="element-104">
              Probás el pack completo. Descargás todos los materiales. Revisás
              los bonos. Y si en 7 días sentís que no era lo que necesitabas, te
              devolvemos el dinero. Sin vueltas. Sin preguntas. Sin
              complicaciones.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}